// extracted by mini-css-extract-plugin
export default {"author":"Parts_author__ork5z","snippet":"Parts_snippet__NZivd","snippet___empty":"Parts_snippet___empty__7YtFF","byline":"Parts_byline__ht6NJ"};